import { render } from "./IconCallSplit.vue?vue&type=template&id=4c5f49a9"
import script from "./IconCallSplit.vue?vue&type=script&lang=js"
export * from "./IconCallSplit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__